export default __webpack_public_path__ + "static/media/VoltageImg.20fcaf54.svg";